import React, {useState} from 'react';
import {Card, CardBody, CardHeader, Table} from "reactstrap";
import minutesToHours from "../../../../../utils/minutesToHours";
import TextLinkType from "../../../TextLinkType";
import WorkParts from "../../../Times/WorkStep/WorkParts";
import {useTecRmi} from "../../../../../contexts/TecRmiContext";
import Button from "../../../../Button";
import classnames from "classnames";
import {useTranslation} from "react-i18next";

const MainWork = props => {
  const { t } = useTranslation('tec_rmi');
  const {serviceProposalWork} = useTecRmi()
  const [adding, setAdding] = useState(false)
  const [added, setAdded] = useState(false)
  const [partsData, setPartsData] = useState()

  return <Card key={'sw' + props.servicePlanPosition.WorkId}>
    <CardHeader className={classnames({
      'd-flex flex-row flex-nowrap align-items-center justify-content-between': true,
      'py-1': !!serviceProposalWork,
    })}>
      <span>
        <span className="text-secondary mr-2">{minutesToHours(props.serviceWork.WorkTime, false, 2)}</span>
        <span>{props.servicePlanPosition.WorkText}</span>
      </span>
      {serviceProposalWork && <Button
        className="my-1"
        size={'sm'}
        color={added ? 'success' : 'primary'}
        loading={adding}
        disabled={added}
        onClick={() => {
          setAdding(true)
          serviceProposalWork
            .fn(props.serviceWork, props.servicePlanPosition, partsData)
            .then(() => {
              setAdding(false)
              setAdded(true)
            })
        }}
      >
        {
          added
            ? <React.Fragment>
              <i className="fas fa-check" />
              <span>Dodano</span>
            </React.Fragment>
            : serviceProposalWork.btnText
        }
      </Button>}
    </CardHeader>
    <CardBody>
      <Table className="table-bordered mb-3">
        <thead>
        <tr>
          <th>{t('scope_of_work')}</th>
        </tr>
        </thead>
        <tbody>
        {props.servicePlanPosition.ServicePlanPositions.map((servicePlanPosition, key) => <tr key={key.toString()}>
          <td>
            <TextLinkType
              linkType={servicePlanPosition.PositionLinkType}
              linkValue={servicePlanPosition.PositionLinkValue}
            >{servicePlanPosition.PositionTextDisplay}</TextLinkType>
          </td>
        </tr>)}
        </tbody>
      </Table>

      <WorkParts
        bodyForTimes={props.bodyForTimes}
        workIds={[props.servicePlanPosition.WorkId]}
        onChange={setPartsData}
      />
    </CardBody>
  </Card>;
};

MainWork.propTypes = {

};

export default MainWork;